var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('site-workflow',{attrs:{"site-id":_vm.rowData.id,"site-name":_vm.rowData.siteName}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }